module.exports = __webpack_public_path__ + "media/icons/balneo-13751582fade1c2d3a67ae11acac9765.svg";